


























































import { Message } from "element-ui";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestCustomDialog extends Vue {
  @Prop()
  visible?:any;

  @Prop()
  config?:any;

  @Prop({ type: String, default: '' })
  versionLabel!: string;

  @Prop({ type: Boolean, default: false })
  submissionLocked!: boolean;

  @Prop({ type: Boolean, default: false })
  submissionBlocked!: boolean;

  chooseResult = '';
  apiLoading = false;

  get getTitle() {
    return this.config?.title??'';
  }
  get getDesc() {
    return this.config?.desc??''
  }
  get getOkText() {
    return this.config?.okText??'';
  }
  get getCancelText() {
    return this.config?.cancelText??this.$tx('common.cancel', '取消');
  }

  get chooseList() {
    return this.config?.items ?? [];
  }

  get isBaselineEdit() {
    return this.config?.type === "smartEditBaseline";
  }

  close() {
    if (this.submissionLocked) return;
    this.$emit('update:visible', false);
    this.apiLoading = false;
  }

  handleClose() {
    if (this.apiLoading || this.submissionLocked || this.submissionBlocked) return;
    // 处理请求，请求完成后关闭弹窗
    this.apiLoading = true;
    this.$emit('confirm', (success:boolean) => {
      this.apiLoading = false;
      if (success) {
        this.$emit('update:visible', false);
      }
    });
  }

}
